import { vnTemplate } from "@valnet/vnKnockoutJsTemplates/vnTemplate";
import { filterDate_template } from "~/components/templates/filterDate_template";
import { multipleSelector_template } from "@valnet/vnKnockoutJsTemplates/multipleSelector_template";
import { presetFilter_template } from "@valnet/vnKnockoutJsTemplates/presetFilter_template";
import { html, LpButton, LpIcon, LpPageHeader, raw } from "~/design-system";
import { createCopyLinkAction } from "~/utils/clipboard";
import { setOptionalIconName } from "~/utils/iconName";
const relativeTimeFormatter = new Intl.RelativeTimeFormat(undefined, {
    numeric: "auto",
});
function parseLastRefreshedAt(value) {
    if (!value) {
        return null;
    }
    const normalizedValue = value.includes("T") ? value : value.replace(" ", "T");
    const date = new Date(normalizedValue);
    return Number.isNaN(date.getTime()) ? null : date;
}
function formatLastRefreshedDateTime(date) {
    return date.toLocaleString(undefined, {
        dateStyle: "medium",
        timeStyle: "short",
    });
}
export class auctionDeliveryHealth_template extends vnTemplate {
    getTemplateHtml() {
        return /* html */ `
            ${LpPageHeader({
            title: "Auction Delivery Health",
            description: "Monitor auction delivery quality, buyer health, error rates, and lead delivery reliability.",
            icon: "heartbeat",
            actions: LpButton({
                label: html `<span data-bind="text: copyLinkLabel"></span>`,
                prefixIcon: "link",
                size: "base",
                variant: "secondary",
                attributes: {
                    "data-bind": "click: onCopyLink",
                },
            }),
            controls: html `
                    <div class="insights-header-controls auction-delivery-health-header-controls" data-bind="css: { 'is-open': showMoreFilters }">
                        <div
                            class="insights-filters-backdrop"
                            data-bind="click: closeMoreFilters, visible: showMoreFilters"
                        ></div>
                        <div class="insights-header-primary">
                            <div class="hidden">
                                ${raw(this.presetFilter.getHtmlBuild())}
                            </div>
                            <div class="auction-insights-filter-cell">
                                <div class="lib-date-picker">
                                    ${raw(this.datesFilter.getHtmlBuild())}
                                </div>
                            </div>
                            <div class="auction-insights-filter-cell">
                                <div class="auction-delivery-health-mode" role="radiogroup" aria-label="Report mode">
                                    <label class="auction-delivery-health-mode__option">
                                        <input
                                            type="radio"
                                            name="auction-delivery-health-mode"
                                            value="aggregator"
                                            data-bind="checked: mode, event: { change: onModeChange }"
                                        >
                                        <span>Aggregator Delivery Health</span>
                                    </label>
                                    <label class="auction-delivery-health-mode__option">
                                        <input
                                            type="radio"
                                            name="auction-delivery-health-mode"
                                            value="buyer"
                                            data-bind="checked: mode, event: { change: onModeChange }"
                                        >
                                        <span>Lead Buyer Health</span>
                                    </label>
                                </div>
                            </div>
                            <div class="auction-insights-filter-cell">
                                <div class="auction-delivery-health-granularity" role="radiogroup" aria-label="Granularity">
                                    <label class="auction-delivery-health-granularity__option">
                                        <input
                                            type="radio"
                                            name="auction-delivery-health-granularity"
                                            value="daily"
                                            data-bind="checked: granularity, event: { change: onGranularityChange }"
                                        >
                                        <span>Daily</span>
                                    </label>
                                    <label class="auction-delivery-health-granularity__option">
                                        <input
                                            type="radio"
                                            name="auction-delivery-health-granularity"
                                            value="hourly"
                                            data-bind="checked: granularity, event: { change: onGranularityChange }"
                                        >
                                        <span>Hourly</span>
                                    </label>
                                    <label class="auction-delivery-health-granularity__option">
                                        <input
                                            type="radio"
                                            name="auction-delivery-health-granularity"
                                            value="totals"
                                            data-bind="checked: granularity, event: { change: onGranularityChange }"
                                        >
                                        <span>Totals</span>
                                    </label>
                                </div>
                            </div>
                            <div class="insights-filters-sheet insights-responsive-filter-sheet">
                                <div class="auction-insights-filter-cell insights-responsive-inline-filter">
                                    ${raw(this.brandFilter.getHtmlBuild())}
                                </div>
                                <div class="auction-insights-filter-cell insights-responsive-inline-filter">
                                    ${raw(this.productFilter.getHtmlBuild())}
                                </div>
                                <div class="auction-insights-filter-cell insights-responsive-inline-filter">
                                    ${raw(this.partnerFilter.getHtmlBuild())}
                                </div>
                                <div class="insights-filters-secondary insights-global-filters">
                                    <header class="insights-global-filters__header">
                                        <h2 class="insights-global-filters__title">Advanced Filters</h2>
                                        ${LpButton({
                ariaLabel: "Close filters",
                prefixIcon: "x",
                size: "sm",
                shape: "square",
                variant: "ghost",
                className: "insights-global-filters__icon-btn",
                attributes: {
                    "data-bind": "click: closeMoreFilters",
                },
            })}
                                    </header>
                                    <div class="insights-global-filters__list insights-advanced-filter-groups">
                                        ${raw(this.getDisplayFiltersHtml())}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="insights-header-actions">
                            ${raw(this.getHeaderActionsHtml())}
                        </div>
                    </div>
                `,
        })}

            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                    <div id="auction-delivery-health-selected-brands"></div>
                    <div id="auction-delivery-health-selected-products"></div>
                    <div id="auction-delivery-health-selected-partners"></div>
                    <div data-bind="visible: mode() === 'buyer'" id="auction-delivery-health-selected-carriers"></div>
                    <div data-bind="visible: mode() === 'buyer'" id="auction-delivery-health-selected-bid-types"></div>
                </div>
            </div>

            <div class="module-grid">
                <div class="data-module">
                    <header class="data-module__header">
                        <div class="data-module__label">
                            <span class="lp-data-table_layer-title-content">
                                ${LpIcon({ name: "heartbeat", size: 16, className: "lp-data-table_layer-title-icon" })}
                                <span data-bind="text: breakdownTitle"></span>
                                <span
                                    class="lp-badge"
                                    data-variant="primary"
                                    data-bind="visible: lastRefreshedLabel, text: lastRefreshedLabel"
                                ></span>
                            </span>
                        </div>
                    </header>
                    <div class="data-module__body" id="list-results">
                        <div class="table-scroll">
                            <div class="table-scroll__wrapper">
                                <table class="tbl auction-delivery-health-table" data-reverse-rows data-bind="visible: mode() === 'aggregator'">
                                    <thead>
                                        <tr>
                                            <th class="tbl-h" rowspan="2">
                                                <div class="tbl-h-inner">
                                                    <span
                                                        class="tbl-h-content icon list-sort-none"
                                                        data-bind="event: { click: onClickReorder.bind($data, 'dateData') }, css: { 'list-sort-desc': orderByAndDirection()=='dateData_DESC', 'list-sort-asc': orderByAndDirection()=='dateData_ASC' }"
                                                    >
                                                        Date
                                                    </span>
                                                </div>
                                            </th>
                                            <th class="tbl-h -center auction-delivery-health__section-heading auction-delivery-health__section-start" colspan="3"><div class="tbl-h-inner"><span class="tbl-h-content">Click Auction</span></div></th>
                                            <th class="tbl-h -center auction-delivery-health__section-heading auction-delivery-health__section-start" colspan="3"><div class="tbl-h-inner"><span class="tbl-h-content">Lead Ping</span></div></th>
                                            <th class="tbl-h -center auction-delivery-health__section-heading auction-delivery-health__section-start" colspan="3"><div class="tbl-h-inner"><span class="tbl-h-content">Lead Post</span></div></th>
                                        </tr>
                                        <tr>
                                            <th class="tbl-h -num auction-delivery-health__section-start"><div class="tbl-h-inner"><span class="tbl-h-content">Total Auction Attempts</span></div></th>
                                            <th class="tbl-h -num"><div class="tbl-h-inner"><span class="tbl-h-content">Auction Failed</span></div></th>
                                            <th class="tbl-h -num auction-delivery-health__error-rate"><div class="tbl-h-inner"><span class="tbl-h-content">Error Rate</span></div></th>
                                            <th class="tbl-h -num auction-delivery-health__section-start"><div class="tbl-h-inner"><span class="tbl-h-content">Total Auction Attempts</span></div></th>
                                            <th class="tbl-h -num"><div class="tbl-h-inner"><span class="tbl-h-content">Auction Failed</span></div></th>
                                            <th class="tbl-h -num auction-delivery-health__error-rate"><div class="tbl-h-inner"><span class="tbl-h-content">Error Rate</span></div></th>
                                            <th class="tbl-h -num auction-delivery-health__section-start"><div class="tbl-h-inner"><span class="tbl-h-content">Total Auction Attempts</span></div></th>
                                            <th class="tbl-h -num"><div class="tbl-h-inner"><span class="tbl-h-content">Auction Failed</span></div></th>
                                            <th class="tbl-h -num auction-delivery-health__error-rate"><div class="tbl-h-inner"><span class="tbl-h-content">Error Rate</span></div></th>
                                        </tr>
                                    </thead>
                                    <tbody data-bind="foreach: listData">
                                        <tr class="tbl-r">
                                            <td class="tbl-c"><div class="tbl-c-inner"><span class="tbl-c-content" data-bind="text: dateData"></span></div></td>
                                            <td class="tbl-c -num auction-delivery-health__section-start"><div class="tbl-c-inner"><span class="tbl-c-content" data-bind="text: $parent.formatNumeric(clickAuctionAttemptCount)"></span></div></td>
                                            <td class="tbl-c -num"><div class="tbl-c-inner"><span class="tbl-c-content" data-bind="text: $parent.formatNumeric(clickAuctionFailureCount)"></span></div></td>
                                            <td class="tbl-c -num auction-delivery-health__error-rate"><div class="tbl-c-inner"><span class="tbl-c-content" data-bind="text: $parent.formatPercent(clickAuctionErrorRate)"></span></div></td>
                                            <td class="tbl-c -num auction-delivery-health__section-start"><div class="tbl-c-inner"><span class="tbl-c-content" data-bind="text: $parent.formatNumeric(leadPingAttemptCount)"></span></div></td>
                                            <td class="tbl-c -num"><div class="tbl-c-inner"><span class="tbl-c-content" data-bind="text: $parent.formatNumeric(leadPingFailureCount)"></span></div></td>
                                            <td class="tbl-c -num auction-delivery-health__error-rate"><div class="tbl-c-inner"><span class="tbl-c-content" data-bind="text: $parent.formatPercent(leadPingErrorRate)"></span></div></td>
                                            <td class="tbl-c -num auction-delivery-health__section-start"><div class="tbl-c-inner"><span class="tbl-c-content" data-bind="text: $parent.formatNumeric(leadPostAttemptCount)"></span></div></td>
                                            <td class="tbl-c -num"><div class="tbl-c-inner"><span class="tbl-c-content" data-bind="text: $parent.formatNumeric(leadPostFailureCount)"></span></div></td>
                                            <td class="tbl-c -num auction-delivery-health__error-rate"><div class="tbl-c-inner"><span class="tbl-c-content" data-bind="text: $parent.formatPercent(leadPostErrorRate)"></span></div></td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table class="tbl auction-delivery-health-table" data-reverse-rows data-bind="visible: mode() === 'buyer'">
                                    <thead>
                                        <tr>
                                            <th class="tbl-h" rowspan="2">
                                                <div class="tbl-h-inner">
                                                    <span
                                                        class="tbl-h-content icon list-sort-none"
                                                        data-bind="event: { click: onClickReorder.bind($data, 'dateData') }, css: { 'list-sort-desc': orderByAndDirection()=='dateData_DESC', 'list-sort-asc': orderByAndDirection()=='dateData_ASC' }"
                                                    >Date</span>
                                                </div>
                                            </th>
                                            <th class="tbl-h" rowspan="2"><div class="tbl-h-inner"><span class="tbl-h-content">Partner</span></div></th>
                                            <th class="tbl-h" rowspan="2"><div class="tbl-h-inner"><span class="tbl-h-content">Carrier</span></div></th>
                                            <th class="tbl-h" rowspan="2"><div class="tbl-h-inner"><span class="tbl-h-content">Bid Type</span></div></th>
                                            <th class="tbl-h -center auction-delivery-health__section-heading auction-delivery-health__section-start" colspan="3"><div class="tbl-h-inner"><span class="tbl-h-content">Lead Post</span></div></th>
                                        </tr>
                                        <tr>
                                            <th class="tbl-h -num auction-delivery-health__section-start">
                                                <div class="tbl-h-inner">
                                                    <span
                                                        class="tbl-h-content icon list-sort-none"
                                                        data-bind="event: { click: onClickReorder.bind($data, 'leadPostAttemptCount') }, css: { 'list-sort-desc': orderByAndDirection()=='leadPostAttemptCount_DESC', 'list-sort-asc': orderByAndDirection()=='leadPostAttemptCount_ASC' }"
                                                    >Total Auction Attempts</span>
                                                </div>
                                            </th>
                                            <th class="tbl-h -num">
                                                <div class="tbl-h-inner">
                                                    <span
                                                        class="tbl-h-content icon list-sort-none"
                                                        data-bind="event: { click: onClickReorder.bind($data, 'leadPostFailureCount') }, css: { 'list-sort-desc': orderByAndDirection()=='leadPostFailureCount_DESC', 'list-sort-asc': orderByAndDirection()=='leadPostFailureCount_ASC' }"
                                                    >Auction Failed</span>
                                                </div>
                                            </th>
                                            <th class="tbl-h -num auction-delivery-health__error-rate">
                                                <div class="tbl-h-inner">
                                                    <span
                                                        class="tbl-h-content icon list-sort-none"
                                                        data-bind="event: { click: onClickReorder.bind($data, 'leadPostErrorRate') }, css: { 'list-sort-desc': orderByAndDirection()=='leadPostErrorRate_DESC', 'list-sort-asc': orderByAndDirection()=='leadPostErrorRate_ASC' }"
                                                    >Error Rate</span>
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody data-bind="foreach: listData">
                                        <tr class="tbl-r">
                                            <td class="tbl-c"><div class="tbl-c-inner"><span class="tbl-c-content" data-bind="text: dateData"></span></div></td>
                                            <td class="tbl-c"><div class="tbl-c-inner"><span class="tbl-c-content" data-bind="text: aggregatorKey"></span></div></td>
                                            <td class="tbl-c"><div class="tbl-c-inner"><span class="tbl-c-content" data-bind="text: carrierKey"></span></div></td>
                                            <td class="tbl-c"><div class="tbl-c-inner"><span class="tbl-c-content" data-bind="text: bidType"></span></div></td>
                                            <td class="tbl-c -num auction-delivery-health__section-start"><div class="tbl-c-inner"><span class="tbl-c-content" data-bind="text: $parent.formatNumeric(leadPostAttemptCount)"></span></div></td>
                                            <td class="tbl-c -num"><div class="tbl-c-inner"><span class="tbl-c-content" data-bind="text: $parent.formatNumeric(leadPostFailureCount)"></span></div></td>
                                            <td class="tbl-c -num auction-delivery-health__error-rate"><div class="tbl-c-inner"><span class="tbl-c-content" data-bind="text: $parent.formatPercent(leadPostErrorRate)"></span></div></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
    getDisplayFiltersHtml() {
        return [
            {
                title: "Lead Buyer Health",
                filters: [
                    this.carrierFilter.getHtmlBuild(),
                    this.bidTypeFilter.getHtmlBuild(),
                ],
                visibleBinding: "mode() === 'buyer'",
            },
        ].map(({ title, filters, visibleBinding }) => (this.getAdvancedFilterGroup(title, filters, visibleBinding))).join("");
    }
    getHeaderActionsHtml() {
        return String(html `
            ${LpButton({
            label: "Filters",
            prefixIcon: "funnel",
            size: "base",
            variant: "ghost",
            className: "auction-delivery-health-filter-trigger",
            attributes: {
                "data-bind": "click: toggleMoreFilters, attr: { 'aria-expanded': showMoreFilters() ? 'true' : 'false' }",
            },
        })}
            ${LpButton({
            label: "Reset",
            prefixIcon: "arrows-clockwise",
            variant: "primary",
            attributes: {
                "data-bind": "click: resetFilters",
            },
        })}
        `);
    }
    getAdvancedFilterGroup(title, filters, visibleBinding) {
        const visibilityAttribute = visibleBinding ? ` data-bind="visible: ${visibleBinding}"` : "";
        return /* html */ `
            <section class="insights-advanced-filter-group"${visibilityAttribute}>
                <h3 class="insights-advanced-filter-group__title">${title}</h3>
                <div class="insights-advanced-filter-group__list">
                    ${filters.map((bodyHtml) => this.getAdvancedFilterControl(bodyHtml)).join("")}
                </div>
            </section>
        `;
    }
    getAdvancedFilterControl(bodyHtml) {
        return /* html */ `
            <div class="insights-advanced-filter">
                ${bodyHtml}
            </div>
        `;
    }
    initPartial() {
        const vm = this.getTemplateViewModel();
        this.presetFilter = new presetFilter_template("presetFilter", vm, this.caller);
        this.presetFilter.setType("auction_delivery_health");
        this.brandFilter = this.buildMultiSelector("brandFilter", "brands", "auction-delivery-health-selected-brands", "Selected brands:", "tag");
        this.productFilter = this.buildMultiSelector("productFilter", "products", "auction-delivery-health-selected-products", "Selected products:", "package");
        this.partnerFilter = this.buildMultiSelector("partnerFilter", "partner", "auction-delivery-health-selected-partners", "Selected partners:", "users");
        this.carrierFilter = this.buildMultiSelector("carrierFilter", "lead buyer", "auction-delivery-health-selected-carriers", "Selected lead buyers:", "users-three");
        this.bidTypeFilter = this.buildMultiSelector("bidTypeFilter", "bid type", "auction-delivery-health-selected-bid-types", "Selected bid types:", "tag");
        this.datesFilter = new filterDate_template("datesFilter", this.getTemplateViewModel(), this.caller);
        this.datesFilter.setStartPickerId("auction-delivery-health-start-date-picker");
        this.datesFilter.setEndPickerId("auction-delivery-health-end-date-picker");
        const date = new Date();
        date.setHours(0, 0, 0, 0);
        let firstOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
        if (date.getTime() === firstOfMonth.getTime()) {
            firstOfMonth = new Date(date.getFullYear(), date.getMonth() - 1, 1);
        }
        this.datesFilter.setDateRange(firstOfMonth, date);
    }
    getTemplateName() {
        return "auctionDeliveryHealth_template";
    }
    getMainElementClasses() {
        return ["w-content", "auction-delivery-health-page"];
    }
    buildViewModel() {
        const self = this;
        const { copyLinkLabel, onCopyLink } = createCopyLinkAction(ko);
        return {
            copyLinkLabel,
            onCopyLink,
            isLoading: ko.observable(0),
            lastRefreshedLabel: ko.observable(""),
            mode: ko.observable("aggregator"),
            granularity: ko.observable("daily"),
            orderBy: ko.observable("dateData"),
            orderByDirection: ko.observable("ASC"),
            orderByAndDirection: ko.observable("dateData_ASC"),
            breakdownTitle: ko.pureComputed(function () {
                const granularity = self.getTemplateViewModel().granularity();
                if (granularity === "totals") {
                    return self.getTemplateViewModel().mode() === "buyer"
                        ? "Buyer Totals"
                        : "Totals";
                }
                const granularityLabel = granularity === "hourly" ? "Hourly" : "Daily";
                return self.getTemplateViewModel().mode() === "buyer"
                    ? `${granularityLabel} Buyer Breakdown`
                    : `${granularityLabel} Breakdown`;
            }),
            listData: ko.observableArray([]),
            showMoreFilters: ko.observable(false),
            onModeChange: function () {
                self.resetSort();
                self.caller.getData();
            },
            onGranularityChange: function () {
                self.caller.getData();
            },
            onClickReorder: function (value, data, event) { self.onClickReorder(value, data, event); },
            resetFilters: function () {
                self.resetFilters();
            },
            toggleMoreFilters: function () {
                const vm = self.getTemplateViewModel();
                const next = !vm.showMoreFilters();
                vm.showMoreFilters(next);
            },
            closeMoreFilters: function () {
                self.getTemplateViewModel().showMoreFilters(false);
            },
            formatNumeric: function (value, digits) {
                return self.formatNumeric(value, digits);
            },
            formatPercent: function (value, digits) {
                return self.formatPercent(value, digits);
            },
        };
    }
    getViewModelForRequest() {
        return {
            filters: {
                selectedBrands: this.brandFilter
                    .getSelectedItems()
                    .map((itemId) => ({ id: itemId })),
                selectedProducts: this.productFilter.getSelectedItems(),
                selectedPartners: this.partnerFilter.getSelectedItems(),
                selectedCarriers: this.carrierFilter.getSelectedItems(),
                selectedBidTypes: this.bidTypeFilter.getSelectedItems(),
                mode: this.getTemplateViewModel().mode(),
                granularity: this.getTemplateViewModel().granularity(),
                dateFilterType: this.datesFilter.getTemplateViewModel().selectedFilter(),
                startDate: this.datesFilter.getTemplateViewModel().startDate(),
                endDate: this.datesFilter.getTemplateViewModel().endDate(),
                startDateRange: this.datesFilter.getTemplateViewModel().fromRange(),
                endDateRange: this.datesFilter.getTemplateViewModel().toRange(),
            },
            sortBy: this.getTemplateViewModel().orderBy(),
            sortDirection: this.getTemplateViewModel().orderByDirection(),
        };
    }
    activateLoading() {
        this.getTemplateViewModel().isLoading(1);
    }
    deactivateLoading() {
        this.getTemplateViewModel().isLoading(0);
    }
    buildDatePickerCalendar() {
        this.datesFilter.buildCalendarWhenReady();
    }
    destroyDatePickerCalendar() {
        this.datesFilter.destroyCalendars();
    }
    setBrandFilterItems(items) {
        this.setMultiSelectItems(this.brandFilter, items || []);
    }
    setProductFilterItems(items) {
        this.setMultiSelectItems(this.productFilter, items || []);
    }
    setPartnerFilterItems(items) {
        this.setMultiSelectItems(this.partnerFilter, items || []);
    }
    setCarrierFilterItems(items) {
        this.setMultiSelectItems(this.carrierFilter, items || []);
    }
    setBidTypeFilterItems(items) {
        this.setMultiSelectItems(this.bidTypeFilter, items || []);
    }
    setListData(data) {
        this.getTemplateViewModel().listData(data || []);
    }
    setStatus(status) {
        const maxDateCreated = status?.maxDateCreated ?? null;
        const label = this.formatLastRefreshedLabel(maxDateCreated);
        this.getTemplateViewModel().lastRefreshedLabel(label);
    }
    setViewModelFromRequest(params) {
        let selectedBrands = params["selectedBrands"];
        if (typeof selectedBrands !== "undefined" && !Array.isArray(selectedBrands)) {
            selectedBrands = [selectedBrands];
        }
        if (Array.isArray(selectedBrands)) {
            const normalizedSelectedBrands = selectedBrands.map((item) => {
                if (typeof item === "object" &&
                    item !== null &&
                    typeof item["id"] !== "undefined") {
                    return item["id"];
                }
                return item;
            });
            this.presetFilter.setMultiSelectorPresetFilters(this.brandFilter, normalizedSelectedBrands);
        }
        this.presetFilter.setMultiSelectorPresetFilters(this.productFilter, params["selectedProducts"]);
        this.presetFilter.setMultiSelectorPresetFilters(this.partnerFilter, params["selectedPartners"]);
        this.presetFilter.setMultiSelectorPresetFilters(this.carrierFilter, params["selectedCarriers"]);
        this.presetFilter.setMultiSelectorPresetFilters(this.bidTypeFilter, params["selectedBidTypes"]);
        if (params["mode"]) {
            this.getTemplateViewModel().mode(params["mode"]);
        }
        if (["daily", "hourly", "totals"].includes(params["granularity"])) {
            this.getTemplateViewModel().granularity(params["granularity"]);
        }
        if (typeof params["sortBy"] !== "undefined") {
            this.getTemplateViewModel().orderBy(params["sortBy"]);
        }
        if (typeof params["sortDirection"] !== "undefined") {
            const direction = String(params["sortDirection"]).toUpperCase() === "DESC" ? "DESC" : "ASC";
            this.getTemplateViewModel().orderByDirection(direction);
            this.getTemplateViewModel().orderByAndDirection(this.getTemplateViewModel().orderBy() + "_" + direction);
        }
        this.presetFilter.setDates(this.datesFilter, params["dateFilterType"], params["startDate"], params["endDate"], params["startDateRange"], params["endDateRange"]);
    }
    formatNumeric(value, digits = 0) {
        let n = Number(value);
        if (isNaN(n)) {
            n = 0;
        }
        return n.toLocaleString("en-EG", {
            minimumFractionDigits: digits,
            maximumFractionDigits: digits,
        });
    }
    formatPercent(value, digits = 2) {
        return this.formatNumeric(value, digits) + "%";
    }
    resetFilters() {
        const date = new Date();
        date.setHours(0, 0, 0, 0);
        let firstOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
        if (date.getTime() === firstOfMonth.getTime()) {
            firstOfMonth = new Date(date.getFullYear(), date.getMonth() - 1, 1);
        }
        this.getTemplateViewModel().mode("aggregator");
        this.datesFilter.setDateRange(firstOfMonth, date);
        this.getTemplateViewModel().granularity("daily");
        this.getTemplateViewModel().orderBy("dateData");
        this.getTemplateViewModel().orderByDirection("ASC");
        this.getTemplateViewModel().orderByAndDirection("dateData_ASC");
        this.resetDisplayFilters(false);
        this.caller.getData();
    }
    resetDisplayFilters(reload = true) {
        this.clearMultiFilterTags(this.brandFilter);
        this.clearMultiFilterTags(this.productFilter);
        this.clearMultiFilterTags(this.partnerFilter);
        this.clearMultiFilterTags(this.carrierFilter);
        this.clearMultiFilterTags(this.bidTypeFilter);
        if (reload) {
            this.caller.getData();
        }
    }
    clearMultiFilterTags(filter) {
        filter.setSeletedItemIds([]);
        const tvm = filter.getTemplateViewModel();
        tvm.openedGroupsDrawers([]);
        const el = filter.getTagContainer();
        if (el) {
            el.innerHTML = "";
        }
    }
    buildMultiSelector(id, label, tagContainerId, tagCaption, iconName) {
        const filter = new multipleSelector_template(id, this.getTemplateViewModel(), this.caller);
        filter.setLabel(label);
        setOptionalIconName(filter, iconName);
        filter.setFilterContainerClass("lib-dropdown");
        filter.setTagContainerId(tagContainerId);
        filter.setTagContainerCaption(tagCaption);
        return filter;
    }
    resetSort() {
        const vm = this.getTemplateViewModel();
        vm.orderBy("dateData");
        vm.orderByDirection("ASC");
        vm.orderByAndDirection("dateData_ASC");
    }
    onClickReorder(value, data, event) {
        const vm = this.getTemplateViewModel();
        if (!this.isSortableColumnForMode(value)) {
            return;
        }
        vm.orderBy(value);
        if (vm.orderByAndDirection() && vm.orderByAndDirection().includes(value)) {
            vm.orderByDirection(vm.orderByDirection() === "DESC" ? "ASC" : "DESC");
        }
        else {
            vm.orderByDirection("DESC");
        }
        vm.orderByAndDirection(value + "_" + vm.orderByDirection());
        this.caller.listReorder();
    }
    isSortableColumnForMode(value) {
        const vm = this.getTemplateViewModel();
        if (vm.mode() === "aggregator") {
            return value === "dateData";
        }
        return [
            "dateData",
            "leadPostAttemptCount",
            "leadPostFailureCount",
            "leadPostErrorRate",
        ].includes(value);
    }
    setMultiSelectItems(filter, items) {
        filter.setItems(items);
    }
    formatLastRefreshedLabel(value) {
        const date = parseLastRefreshedAt(value);
        if (!date) {
            return "";
        }
        const elapsed = Math.max(0, Date.now() - date.getTime());
        const minute = 60_000;
        const hour = 60 * minute;
        const day = 24 * hour;
        const dateTime = formatLastRefreshedDateTime(date);
        if (elapsed < minute) {
            return `Last refreshed just now · ${dateTime}`;
        }
        if (elapsed < hour) {
            return `Last refreshed ${relativeTimeFormatter.format(-Math.max(1, Math.floor(elapsed / minute)), "minute")} · ${dateTime}`;
        }
        if (elapsed < day) {
            return `Last refreshed ${relativeTimeFormatter.format(-Math.max(1, Math.floor(elapsed / hour)), "hour")} · ${dateTime}`;
        }
        return `Last refreshed ${relativeTimeFormatter.format(-Math.max(1, Math.round(elapsed / day)), "day")} · ${dateTime}`;
    }
}
